export const isProPlan = plan => ['pro', 'pro_plus'].includes(plan);
export const planLabel = plan => plan === 'pro_plus' ? 'Pro Plus' : plan === 'pro' ? 'Pro' : 'Free';
export const remainingUses = (plan, key) => plan?.limits?.[key] === null ? Infinity
  : Math.max(0, (plan?.limits?.[key] ?? 0) - (plan?.usage_today?.[key] ?? 0));
export const dailyLimitLabel = value => value === null ? 'Sınırsız' : `${value}/gün`;
